import React from "react";

const ArrowIcon = () => {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.414 5.954L0.546 4.806C1.29267 4.34867 1.94133 3.90533 2.492 3.476C3.04267 3.04667 3.53733 2.60333 3.976 2.146C4.424 1.68867 4.83467 1.19867 5.208 0.676H5.292C5.67467 1.19867 6.08067 1.68867 6.51 2.146C6.94867 2.60333 7.448 3.04667 8.008 3.476C8.568 3.90533 9.21667 4.34867 9.954 4.806L9.072 5.954C8.484 5.57133 7.95667 5.17933 7.49 4.778C7.02333 4.36733 6.61733 3.966 6.272 3.574C5.936 3.17267 5.66067 2.78067 5.446 2.398C5.24067 2.01533 5.096 1.65133 5.012 1.306H5.488C5.404 1.65133 5.25467 2.01533 5.04 2.398C4.82533 2.78067 4.54533 3.17267 4.2 3.574C3.864 3.966 3.46267 4.36733 2.996 4.778C2.53867 5.17933 2.01133 5.57133 1.414 5.954ZM4.494 10V5.534C4.494 4.89 4.51733 4.31133 4.564 3.798C4.61067 3.28467 4.67133 2.818 4.746 2.398L5.25 1.46L5.754 2.398C5.82867 2.818 5.88467 3.28467 5.922 3.798C5.96867 4.31133 5.992 4.89 5.992 5.534V10H4.494Z"
        fill="#3A383F"
      />
    </svg>
  );
};

export default ArrowIcon;
